module.exports = __webpack_public_path__ + "img/36.83ecead0.jpg";